module.exports = __webpack_public_path__ + "assets/c66c5c026f1457488530ce189707c3b5.png";